import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import Svg, { Polygon } from 'react-native-svg';

const FlatTopHexagon = ({ percentage = 0, disabled = false }) => {
  const width = 80;
  const height = 69;

  return (
    <View style={[styles.container, { width, height }]}>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 69 69" // keeps shape proportions
        preserveAspectRatio="none" // allows horizontal stretch
        style={styles.hexagon}
      >
        <Polygon
          points="17.99,0 51.01,0 69,34.5 51.01,69 17.99,69 0,34.5"
          fill={disabled ? '	#E0E0E0' : percentage === 0 ? '#FEDD88' : '#FFB800'}
        />
      </Svg>

      <View style={styles.textContainer}>
        <Text style={styles.text}>{percentage}%</Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  hexagon: {
    position: 'absolute',
  },
  textContainer: {
    position: 'absolute',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    fontFamily: 'Secular One',
    fontWeight: '400',
    fontStyle: 'normal',
    fontSize: 20,

    textAlign: 'center',
  },
});

export default FlatTopHexagon;
